export default [
  {
    path: '/aging',
    component: () => import('@/views/Index'),
    children: [
      {
        name: 'Aging Historico',
        path: 'historico',
        component: () => import('@/views/aging/Historico.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [{ name: 'Power Ups', path: '/powerups' }, { name: 'Aging' }]
        }
      },
      {
        name: 'Aging Adicionar',
        path: 'edit',
        component: () => import('@/views/aging/Edit.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [
            { name: 'Power Ups', path: '/powerups' },
            { name: 'Aging', path: '/aging/historico' },
            { name: 'Adicionar' }
          ]
        }
      },
      {
        name: 'Aging Editar',
        path: 'edit/:id',
        component: () => import('@/views/aging/Edit.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [{ name: 'Power Ups', path: '/powerups' }, { name: 'Aging', path: '/aging/historico' }, { name: 'Editar' }]
        }
      },
      {
        name: 'Painel Gerencial Aging',
        path: 'painel-gerencial/:id',
        component: () => import('@/views/aging/PainelGerencial.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [
            { name: 'Power Ups', path: '/powerups' },
            { name: 'Aging', path: '/aging/historico' },
            { name: 'Painel Gerencial' }
          ]
        }
      }
    ]
  }
];
